import { AxiosRequestConfig, AxiosResponse } from 'axios';
import { PaginationRestDTO } from '@bottega52/commons-pagination';
import { JagoAxiosInstance } from './JagoAxiosInstance';
import { IParamConfigurationInDTO } from './model/input/IParamConfigurationInDTO';
import { IParamConfigurationCreateOutDTO, IParamConfigurationUpdateOutDTO } from './model/output/IParamConfigurationOutDTO';

export interface IParamConfigurationRequestParams {
  page?: number;
  pageSize?: number;
  name?: string;
}

export function fetchParamConfigurations(params?: IParamConfigurationRequestParams): Promise<AxiosResponse<PaginationRestDTO<IParamConfigurationInDTO>>> {
  const config: AxiosRequestConfig = {
    params,
  };
  return JagoAxiosInstance.get('api/v2/support/paramConfigurations', config);
}

export function fetchParamPublicConfiguration(): Promise<AxiosResponse<IParamConfigurationInDTO[]>> {
  return JagoAxiosInstance.get('api/v2/support/paramConfigurations/public');
}

export function fetchParamConfiguration(id: number): Promise<AxiosResponse<IParamConfigurationInDTO>> {
  return JagoAxiosInstance.get(`api/v2/support/paramConfigurations/${id}`);
}

export function createParamConfiguration(data: IParamConfigurationCreateOutDTO): Promise<AxiosResponse<IParamConfigurationInDTO>> {
  return JagoAxiosInstance.post('api/v2/support/paramConfigurations', data);
}

export function updateParamConfiguration(id: number, data: IParamConfigurationUpdateOutDTO): Promise<AxiosResponse<IParamConfigurationInDTO>> {
  return JagoAxiosInstance.put(`api/v2/support/paramConfigurations/${id}`, data);
}

export function deleteParamConfiguration(id: number): Promise<AxiosResponse<void>> {
  return JagoAxiosInstance.delete(`api/v2/support/paramConfigurations/${id}`);
}
